var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activeProductData
    ? _c(
        "div",
        {
          staticClass: "configurator",
          class: { "configurator--loading": _vm.isLoading }
        },
        [
          _c("p", { staticClass: "configurator__cta" }, [
            _vm._v(
              _vm._s(_vm.$translate("Weberbuero::Template.configuratorCTA")) +
                ":"
            )
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "configurator-variants__list" },
            _vm._l(_vm.productList, function(product) {
              return _c(
                "li",
                {
                  staticClass: "configurator-variants__item",
                  class: {
                    "configurator-variants__item--active":
                      _vm.activeProductData.id === product.id
                  },
                  on: {
                    click: function($event) {
                      return _vm.switchArticle(product.varId)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "configurator-variants__img-wrap" },
                    [
                      _c(
                        "div",
                        { staticClass: "configurator-variants__img-container" },
                        [
                          _c("lazy-img", {
                            staticClass: "configurator-variants__img",
                            attrs: {
                              "is-background-image": true,
                              "image-url":
                                "https://bilder.weberbuero.de/frontend/images/materials/thumbs/" +
                                product.img +
                                ".jpg"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "configurator-variants__title" }, [
                    _c("p", [_vm._v(_vm._s(product.name))])
                  ])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "configurator__container" }, [
            _c(
              "p",
              { staticClass: "configurator__cta" },
              [
                _vm._v(
                  _vm._s(
                    _vm.$translate("Weberbuero::Template.configuratorCTA2")
                  ) + ":\n            "
                ),
                _vm._l(_vm.activeColorList, function(color, key) {
                  return parseInt(color.attributeValueId) ===
                    _vm.activeColor.value && _vm.varSwitched
                    ? [_vm._v(_vm._s(color.name) + "\n            ")]
                    : _vm._e()
                })
              ],
              2
            ),
            _vm._v(" "),
            _vm.isLoading
              ? _c("div", { staticClass: "configurator__loading" })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { ref: "swiper", staticClass: "swiper-container conf-swiper" },
              [
                _vm.activeAttributes &&
                _vm.activeAttributes[_vm.swiperColor] &&
                _vm.activeColorList.length > 5
                  ? _c(
                      "div",
                      { staticClass: "configurator__item-wrapper" },
                      [
                        _vm._l(_vm.activeColorList, function(color, key) {
                          return key < 4 ||
                            parseInt(color.attributeValueId) ===
                              _vm.activeColor.value
                            ? _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !(
                                        key > 4 &&
                                        parseInt(color.attributeValueId) ===
                                          _vm.activeColor.value
                                      ),
                                      expression:
                                        "!(key > 4 && parseInt(color.attributeValueId) === activeColor.value)"
                                    }
                                  ],
                                  staticClass: "configurator__item"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.selectAttribute(
                                            _vm.swiperColor,
                                            color.attributeValueId
                                          )
                                          _vm.clickCount++
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "lazy-img",
                                        {
                                          staticClass:
                                            "configurator__color-card",
                                          class: {
                                            "configurator__color-card--active":
                                              parseInt(
                                                color.attributeValueId
                                              ) === _vm.activeColor.value &&
                                              _vm.varSwitched,
                                            sold: !_vm.isAttributeSelectionValid(
                                              color.attributeId,
                                              color.attributeValueId,
                                              true
                                            )
                                          },
                                          attrs: {
                                            "is-background-image": true,
                                            "image-url":
                                              "https://bilder.weberbuero.de/frontend/images/materials/thumbs/" +
                                              color.name.split(" ")[0] +
                                              ".jpg"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "configurator__label"
                                            },
                                            [
                                              _c("p", [
                                                _vm._v(_vm._s(color.name))
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _vm.sidebarContent ===
                        _vm.activeAttributes[_vm.swiperColor].attributeId
                          ? _c("portal", { attrs: { to: "sidebar" } }, [
                              _c(
                                "span",
                                {
                                  staticClass: "single__variations-select-label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Weberbuero::Template.configuratorCTA2"
                                      )
                                    ) + ":"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "configurator__item-wrapper" },
                                _vm._l(_vm.activeColorList, function(
                                  color,
                                  key
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "configurator__item",
                                      class: {
                                        active:
                                          parseInt(color.attributeValueId) ===
                                          _vm.activeColor.value
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.selectAttribute(
                                                _vm.swiperColor,
                                                color.attributeValueId
                                              )
                                              _vm.toggleSidebar()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "lazy-img",
                                            {
                                              staticClass:
                                                "configurator__color-card",
                                              class: {
                                                "configurator__color-card--active":
                                                  color.attributeValueId ===
                                                    _vm.activeColor.value &&
                                                  _vm.currentVariation
                                                    .attributes.length > 0,
                                                sold: !_vm.isAttributeSelectionValid(
                                                  color.attributeId,
                                                  color.attributeValueId,
                                                  true
                                                )
                                              },
                                              attrs: {
                                                "is-background-image": true,
                                                "image-url":
                                                  "https://bilder.weberbuero.de/frontend/images/materials/thumbs/" +
                                                  color.name.split(" ")[0] +
                                                  ".jpg"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "configurator__label"
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(_vm._s(color.name))
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "configurator__item" }, [
                          _c(
                            "div",
                            {
                              staticClass: "sidebar-toggle",
                              on: {
                                click: function($event) {
                                  return _vm.toggleSidebar(
                                    _vm.activeAttributes[_vm.swiperColor]
                                      .attributeId
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "34",
                                    height: "34",
                                    viewBox: "0 0 34 34",
                                    fill: "none"
                                  }
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "mix-blend-mode": "multiply"
                                      }
                                    },
                                    [
                                      _c("circle", {
                                        attrs: {
                                          cx: "17",
                                          cy: "17",
                                          r: "17",
                                          fill: "#3F3F3F"
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d:
                                        "M17 17V23M11 17H17H11ZM23 17H17H23ZM17 17V11V17Z",
                                      stroke: "white",
                                      "stroke-width": "1.5",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", [_vm._v("Alle ansehen")])
                            ]
                          )
                        ])
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeAttributes &&
                _vm.activeAttributes[_vm.swiperColor] &&
                _vm.activeColorList.length <= 5
                  ? _c(
                      "div",
                      { staticClass: "configurator__item-wrapper" },
                      _vm._l(_vm.activeColorList, function(color, key) {
                        return key < 4
                          ? _c("div", { staticClass: "configurator__item" }, [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.selectAttribute(
                                        _vm.swiperColor,
                                        color.attributeValueId
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "lazy-img",
                                    {
                                      staticClass: "configurator__color-card",
                                      class: {
                                        "configurator__color-card--active":
                                          color.attributeValueId ===
                                            _vm.activeColor.value &&
                                          _vm.varSwitched,
                                        sold: !_vm.isAttributeSelectionValid(
                                          _vm.activeColor.value,
                                          color.attributeValueId,
                                          true
                                        )
                                      },
                                      attrs: {
                                        "is-background-image": true,
                                        "image-url":
                                          "https://bilder.weberbuero.de/frontend/images/materials/thumbs/" +
                                          color.name.split(" ")[0] +
                                          ".jpg"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "configurator__label" },
                                        [_c("p", [_vm._v(_vm._s(color.name))])]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      }),
                      0
                    )
                  : _vm._e()
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "configurator__muster" }, [
            _c(
              "a",
              {
                staticClass: "js--single__muster-link single__muster-link",
                attrs: {
                  href: "#",
                  "data-toggle": "modal",
                  "data-target": "#confi-muster"
                },
                on: {
                  click: function($event) {
                    return _vm.detachModal()
                  }
                }
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "svg_gift",
                    attrs: { width: "16", height: "20" }
                  },
                  [
                    _c("use", {
                      attrs: {
                        "xlink:href": "#svg_cards",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink"
                      }
                    })
                  ]
                ),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.activeProductData.name) +
                    " " +
                    _vm._s(_vm.$translate("Weberbuero::Template.orderMuster")) +
                    "  \n        "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _vm.activeAttributes
            ? _c(
                "div",
                { staticClass: "configurator__row configurator__select-list" },
                _vm._l(_vm.attributeSelectList, function(attribute, key) {
                  return _c(
                    "div",
                    { staticClass: "configurator__col" },
                    [
                      attribute.type === "image"
                        ? [
                            attribute.values.length > 4
                              ? _c(
                                  "div",
                                  { staticClass: "configurator__select-img" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "single__variations-select-label"
                                      },
                                      [_vm._v(_vm._s(attribute.name) + ":")]
                                    ),
                                    _vm._v(" "),
                                    _vm.selectedAttributes[
                                      attribute.attributeId
                                    ] !== null
                                      ? _vm._l(attribute.values, function(
                                          value,
                                          key2
                                        ) {
                                          return value.attributeValueId ==
                                            _vm.selectedAttributes[
                                              attribute.attributeId
                                            ]
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "configurator__select-list-outer-button configurator__select-list-outer-button--img",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toggleSidebar(
                                                        attribute.attributeId
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "configurator__select-list-outer-button-content"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "configurator__select-list-outer-button-img-wrapper"
                                                        },
                                                        [
                                                          _c("lazy-img", {
                                                            staticClass: "p-1",
                                                            attrs: {
                                                              "image-url":
                                                                value.imageUrl,
                                                              alt: value.name
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(value.name) +
                                                            "\n                      "
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "single__select--right",
                                                      attrs: {
                                                        height: "7",
                                                        width: "11"
                                                      }
                                                    },
                                                    [
                                                      _c("use", {
                                                        attrs: {
                                                          "xlink:href":
                                                            "#svg_arrow",
                                                          "xmlns:xlink":
                                                            "http://www.w3.org/1999/xlink"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.sidebarContent === attribute.attributeId
                                      ? _c(
                                          "portal",
                                          { attrs: { to: "sidebar" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "single__variations-select-label"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(attribute.name) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "configurator__select-list configurator__select-list--img"
                                              },
                                              _vm._l(attribute.values, function(
                                                value,
                                                key2
                                              ) {
                                                return _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "configurator__select-list-item",
                                                    class: {
                                                      active:
                                                        value.attributeValueId ==
                                                        _vm.selectedAttributes[
                                                          attribute.attributeId
                                                        ],
                                                      sold: !_vm.isAttributeSelectionValid(
                                                        attribute.attributeId,
                                                        value.attributeValueId,
                                                        true
                                                      )
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.selectAttribute(
                                                          attribute.attributeId,
                                                          value.attributeValueId
                                                        )
                                                        _vm.toggleSidebar()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "configurator__select-list-item-img-wrapper"
                                                      },
                                                      [
                                                        _c("lazy-img", {
                                                          staticClass: "p-1",
                                                          attrs: {
                                                            "image-url":
                                                              value.imageUrl,
                                                            alt: value.name
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(value.name) +
                                                          "\n                      "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              }),
                                              0
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : [
                                  _c(
                                    "div",
                                    { staticClass: "configurator__select-img" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "single__variations-select-label"
                                        },
                                        [
                                          _vm._v(_vm._s(attribute.name) + ": "),
                                          _vm._l(attribute.values, function(
                                            value
                                          ) {
                                            return value.attributeValueId ==
                                              _vm.selectedAttributes[
                                                attribute.attributeId
                                              ]
                                              ? _c("span", [
                                                  _vm._v(_vm._s(value.name))
                                                ])
                                              : _vm._e()
                                          })
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "configurator__select-img-item-wrapper"
                                        },
                                        _vm._l(attribute.values, function(
                                          value
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              staticClass:
                                                "configurator__select-img-item",
                                              class: {
                                                active:
                                                  value.attributeValueId ==
                                                  _vm.selectedAttributes[
                                                    attribute.attributeId
                                                  ],
                                                sold: !_vm.isAttributeSelectionValid(
                                                  attribute.attributeId,
                                                  value.attributeValueId,
                                                  true
                                                )
                                              },
                                              attrs: {
                                                "data-toggle": "tooltip",
                                                "data-placement": "top",
                                                title: value.name
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.selectAttribute(
                                                    attribute.attributeId,
                                                    value.attributeValueId
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("lazy-img", {
                                                staticClass: "p-1",
                                                attrs: {
                                                  "image-url": value.imageUrl,
                                                  alt: value.name
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                ]
                          ]
                        : [
                            _c(
                              "div",
                              { staticClass: "configurator__select" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "single__variations-select-label"
                                  },
                                  [_vm._v(_vm._s(attribute.name))]
                                ),
                                _vm._v(" "),
                                attribute.values.length > 3
                                  ? [
                                      _vm.selectedAttributes[
                                        attribute.attributeId
                                      ] !== null
                                        ? _vm._l(attribute.values, function(
                                            value,
                                            key2
                                          ) {
                                            return value.attributeValueId ==
                                              _vm.selectedAttributes[
                                                attribute.attributeId
                                              ]
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "configurator__select-list-outer-button",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.toggleSidebar(
                                                          attribute.attributeId
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(_vm._s(value.name))
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass:
                                                          "single__select--right",
                                                        attrs: {
                                                          height: "7",
                                                          width: "11"
                                                        }
                                                      },
                                                      [
                                                        _c("use", {
                                                          attrs: {
                                                            "xlink:href":
                                                              "#svg_arrow",
                                                            "xmlns:xlink":
                                                              "http://www.w3.org/1999/xlink"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          })
                                        : _c("div", [
                                            _vm._v(
                                              _vm._s(attribute.values[0].name)
                                            )
                                          ])
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                attribute.values.length > 3
                                  ? [
                                      _vm.sidebarContent ===
                                      attribute.attributeId
                                        ? _c(
                                            "portal",
                                            { attrs: { to: "sidebar" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "single__variations-select-label"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(attribute.name) + ":"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "ul",
                                                {
                                                  staticClass:
                                                    "configurator__select-list"
                                                },
                                                _vm._l(
                                                  attribute.values,
                                                  function(value, key2) {
                                                    return _c(
                                                      "li",
                                                      {
                                                        staticClass:
                                                          "configurator__select-list-item",
                                                        class: {
                                                          active:
                                                            value.attributeValueId ==
                                                            _vm
                                                              .selectedAttributes[
                                                              attribute
                                                                .attributeId
                                                            ],
                                                          sold: !_vm.isAttributeSelectionValid(
                                                            attribute.attributeId,
                                                            value.attributeValueId,
                                                            true
                                                          )
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.selectAttribute(
                                                              attribute.attributeId,
                                                              value.attributeValueId
                                                            )
                                                            _vm.toggleSidebar()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                    " +
                                                            _vm._s(value.name) +
                                                            "\n                                "
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "configurator__select-buttons-wrapper"
                                      },
                                      _vm._l(attribute.values, function(
                                        value,
                                        key2
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            staticClass:
                                              "configurator__select-button",
                                            class: {
                                              active:
                                                value.attributeValueId ==
                                                _vm.selectedAttributes[
                                                  attribute.attributeId
                                                ],
                                              sold: !_vm.isAttributeSelectionValid(
                                                attribute.attributeId,
                                                value.attributeValueId,
                                                true
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.selectAttribute(
                                                  attribute.attributeId,
                                                  value.attributeValueId
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(value.name) +
                                                "\n                        "
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                              ],
                              2
                            )
                          ]
                    ],
                    2
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          this.colorArray.length > 0 && _vm.modalSelectedColor.id
            ? _c("DetailsModal", {
                attrs: {
                  activeAttributes: _vm.activeAttributes,
                  colorArray: _vm.colorArray,
                  swiperColor: _vm.swiperColor,
                  modalSelectedColor: _vm.modalSelectedColor
                },
                on: { selectModalColor: _vm.selectModalColor }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("MusterModal", {
            attrs: {
              modalActiveArticle: _vm.modalActiveArticle,
              productList: _vm.productList,
              modalSelectedMuster: _vm.modalSelectedMuster
            },
            on: { switchMuster: _vm.switchMuster }
          }),
          _vm._v(" "),
          _vm._l(_vm.confiArticleList, function(item, index) {
            return _c("input", {
              class: "confiArticleListItemId" + index,
              attrs: { type: "hidden" },
              domProps: { value: item.id }
            })
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }